// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"cdbb3f0f","494":"c795c62b","697":"55531498"}[chunkId] + ".chunk.js";
};